import { render, staticRenderFns } from "./organization-signups.vue?vue&type=template&id=76650520&"
import script from "./organization-signups.vue?vue&type=script&lang=js&"
export * from "./organization-signups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports